import { RootState } from '@/redux-store/types';

export const selectIsQuickPlanningEnabled = (state: RootState) => state.reducer.schedule.quickPlanning.enabled;

export const selectShortcutForNewFreeDay = (state: RootState) => state.reducer.schedule.quickPlanning.freeDayShortcut;

export const selectBorderCell = (state: RootState) => state.reducer.schedule.quickPlanning.position.borderCell;

export const selectQuickPlanningSelected = (state: RootState) => state.reducer.schedule.quickPlanning.selected;
